'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = shouldPrependPortalOnStep;

var _appStepRoutes = require('../constants/appStepRoutes');

var PREPEND_PORTAL_STEPS = [_appStepRoutes.JOIN_HUBSPOT_EMPLOYEE];

function shouldPrependPortalOnStep(step) {
  return PREPEND_PORTAL_STEPS.includes(step);
}
module.exports = exports['default'];